

//----- ip -----
// const dominio = "http://192.168.0.79:5000";

//----- Local ------
// const dominio = "http://192.168.0.79:5000";


//----- Pruebas 23 ------
//  const dominio = "http://190.56.9.222:5790";


//----- Pruebas ------
//  const dominio = "http://192.168.1.79:5000";


//----- Publica ------
const dominio = "http://190.56.9.222:5000";


 const dominioMOSA = "http://190.56.9.222:3050";
//const dominioMOSA = "http://192.168.0.79:3050";

 const dominioTRANSFLESA = "http://190.56.9.222:7000";


const rutas = {


//----------- NUEVOS -----------------

nombre: `${dominio}/ruta`,
get_list_autorizaciones: `${dominio}/get_list_autorizaciones`,

};

module.exports = {
  dominio,
  rutas,
  dominioMOSA,
  dominioTRANSFLESA
};
